import { gql } from 'graphql-request'

export const GET_USER_TASK_HOST_FIRST = gql`
  query GET_USER_TASK_HOST_FIRST(
    $userId: Int
    $userTaskHostDefaultId: Int
    $dateTaskInitial: String
    $dateTaskFinal: String
    $typeFilterDateTask: TypeFilter
  ) {
    getUserTaskHostFirst(
      userId: $userId
      userTaskHostDefaultId: $userTaskHostDefaultId
      dateTaskInitial: $dateTaskInitial
      dateTaskFinal: $dateTaskFinal
      typeFilterDateTask: $typeFilterDateTask
    ) {
      error
      status
      data {
        id
        userId
        user {
          id
          username
        }
        userTaskHostDefaultId
        userTaskHostDefault {
          id
          name
          value
        }
        userTaskHostType
        userTaskBonusType
        iconUserTaskHost
        dateTask
        quantityTask
        quantityCompleted
        completed
        rescued
        createdAt
        updatedAt
      }
    }
  }
`

export const GET_USERS_TASKS_HOSTS = gql`
  query GET_USERS_TASKS_HOSTS(
    $take: Int
    $skip: Int
    $userId: Int
    $userTaskHostDefaultId: Int
    $userTaskHostType: UserTaskHostType
    $userTaskBonusType: UserTaskBonusType
    $completed: Boolean
    $rescued: Boolean
    $typeFilterCreatedAt: TypeFilter
    $createdAtInitial: String
    $createdAtFinal: String
    $itemPackageId: Int
    $typeFilterDateTask: TypeFilter
    $dateTaskInitial: String
    $dateTaskFinal: String
    $typeFilterQuantityTask: TypeFilter
    $quantityTaskInitial: Float
    $quantityTaskFinal: Float
    $typeFilterQuantityCompleted: TypeFilter
    $quantityCompletedInitial: Float
    $quantityCompletedFinal: Float
    $typeFilterDateRescued: TypeFilter
    $dateRescuedInitial: String
    $dateRescuedFinal: String
  ) {
    getUsersTasksHosts(
      take: $take
      skip: $skip
      userId: $userId
      itemPackageId: $itemPackageId
      typeFilterDateTask: $typeFilterDateTask
      dateTaskInitial: $dateTaskInitial
      dateTaskFinal: $dateTaskFinal
      typeFilterDateRescued: $typeFilterDateRescued
      dateRescuedInitial: $dateRescuedInitial
      dateRescuedFinal: $dateRescuedFinal
      typeFilterQuantityTask: $typeFilterQuantityTask
      quantityTaskInitial: $quantityTaskInitial
      quantityTaskFinal: $quantityTaskFinal
      typeFilterQuantityCompleted: $typeFilterQuantityCompleted
      quantityCompletedInitial: $quantityCompletedInitial
      quantityCompletedFinal: $quantityCompletedFinal
      userTaskHostDefaultId: $userTaskHostDefaultId
      userTaskHostType: $userTaskHostType
      userTaskBonusType: $userTaskBonusType
      completed: $completed
      rescued: $rescued
      typeFilterCreatedAt: $typeFilterCreatedAt
      createdAtInitial: $createdAtInitial
      createdAtFinal: $createdAtFinal
    ) {
      error
      status
      totalPages
      data {
        completed
        createdAt
        dateRescued
        dateTask
        iconUserTaskHost
        id
        itemPackage {
          id
        }
        itemPackageId
        quantityCompleted
        quantityTask
        rescued
        updatedAt
        user {
          id
          username
        }
        userId
        userTaskBonusType
        userTaskHostDefault {
          id
          name
          value
        }
        userTaskHostDefaultId
        userTaskHostType
      }
    }
  }
`
